<template>
    <div class="settings-message-default-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Editar Mensagem Padrão</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Default Message -->
        <mu-form-default-message type="edit"></mu-form-default-message>

    </div>
</template>

<script>
    export default {
        name: 'app-settings-message-default',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Mensagem Padrão',
                        route: 'app.settings.messagedefault',
                        disabled: false
                    },
                    {
                        text: 'Editar Mensagem Padrão',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
